import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  presetForOtherThanHeaderItemsColors,
  presetHeaderColors,
} from './mj-listing-item-paint-button.config';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-listing-item-paint-button',
  templateUrl: './mj-listing-item-paint-button.component.html',
  styleUrls: ['./mj-listing-item-paint-button.component.scss'],
})
export class MjListingItemPaintButtonComponent implements OnInit {
  @Input() public listingItem: JobListingItem;
  @Input() public position = 'bottom';

  @Output() public isColorPickerOn = new EventEmitter<{}>();

  public colorShouldBeShown = { isOn: false };
  public presentColors: string[];

  ngOnInit() {
    this.presentColors =
      this.listingItem.type === LISTING_ITEM_TYPE.LISTING_ITEM_HEADER
        ? presetHeaderColors
        : presetForOtherThanHeaderItemsColors;
  }

  public showColorOptions() {
    this.colorShouldBeShown.isOn = !this.colorShouldBeShown.isOn;
    this.isColorPickerOn.emit(this.colorShouldBeShown);
  }

  public setColor($event) {
    this.listingItem.background_rgba = $event;
  }
}
